var _path, _circle, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFreeLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0204 25.8545C29.6925 24.5939 30.4252 23.2197 30.4252 21.32C30.4252 16.098 27.0127 15.5293 25.3065 15.5293C23.8815 15.5293 23.2195 18.2843 22.9008 19.6106L22.8941 19.6381C22.5241 21.1784 22.1413 22.7712 21.0889 23.8257C20.0005 24.9159 19.156 26.1471 18.2722 27.4357C17.2816 28.88 16.2416 30.3964 14.7532 31.8671C14.5914 32.0271 14.5002 32.2454 14.5002 32.4729V47.6706C14.5002 48.1357 14.873 48.5151 15.3379 48.5236C16.4634 48.5443 17.9467 49.1691 19.0811 49.6738C21.3386 50.6781 24.1482 51.928 27.5811 51.9292L27.7833 51.9293C30.8245 51.9293 34.4209 51.8999 35.8719 49.8152C36.4685 48.958 36.6145 47.8932 36.309 46.6421C37.4687 45.4298 38.0908 43.1683 37.4736 41.3274C38.721 39.6615 38.8346 37.3367 38.1354 35.6776L38.1432 35.6698C38.9887 34.8204 39.5311 33.4475 39.5252 32.1722C39.5141 30.0144 37.6656 28.0418 35.2913 28.0418H28.0595C28.2517 27.2962 28.6256 26.595 29.0204 25.8545ZM7.1064 30.3164H12.7939C13.7362 30.3164 14.5001 31.0803 14.5001 32.0227V49.0852C14.5001 50.0275 13.7362 50.7914 12.7939 50.7914H7.1064C6.16405 50.7914 5.40015 50.0275 5.40015 49.0852V32.0227C5.40015 31.0803 6.16405 30.3164 7.1064 30.3164Z",
    fill: "url(#paint0_linear_42_17192)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 12,
    r: 9,
    fill: "url(#paint1_linear_42_17192)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4712 11.1191L42.2896 14.9375L47.3807 9.84635",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_17192",
    x1: 9.23922,
    y1: 22.3543,
    x2: 35.3025,
    y2: 24.5212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_17192",
    x1: 36.025,
    y1: 6.375,
    x2: 49.7596,
    y2: 7.59305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFreeLog);
export default __webpack_public_path__ + "static/media/icon_free_log.8336ebcb6dd6bb25a69f406ce0969a7a.svg";
export { ForwardRef as ReactComponent };